<div class="flex flex-col w-full gap-4">
  <!-- Header and preview of the current selected file - only displayed, if current item is set -->
  @if (currentFile) {
    <div class="flex justify-between w-full flex-shrink-0">
      <nrc-media-preview
        class="overflow-hidden shadow-inner w-28 h-28 rounded-10"
        [mimetype]="currentFile.mimetype"
        [source]="currentFile.source"
        [thumbnailSource]="currentFile.thumbnail"
        [mediaPreviewTypes]="['image', 'video-snippet']"
      />

      <form class="flex flex-col justify-start pl-5 space-y-3 grow" [formGroup]="fileTitleForm">
        <div class="w-full">
          @if (fileTitleForm) {
            <nrc-input-text
              class="w-full"
              [formControl]="fileTitleForm.controls['title']"
              [type]="'text'"
              [name]="'file-replace-title'"
              [id]="'file-replace-title'"
              [label]="'COMPONENTS.FILE_REPLACER.INPUTS.TITLE.LABEL' | translate"
              [classList]="['bg-white/25']"
              [readonly]="true"
            />
          }

          <div class="w-full">
            <span class="text-xs font-light text-white/50">
              {{ currentFile | extractProperties: [{ key: 'extension', format: objectPropertyFormat.TEXT }, { key: 'createdAt', format: objectPropertyFormat.DATE}, { key: 'size', format: objectPropertyFormat.FILE_SIZE }] | join: ' | ' }}
            </span>
          </div>
        </div>

        <nrc-note
          class="w-full"
          [message]="{
            message: 'COMPONENTS.FILE_REPLACER.NOTE.MESSAGE.MESSAGE' | translate,
            level: level.WARN
          }"
        />
      </form>
    </div>
  }

  <!-- The selection to either upload a file or go to the file library. -->
  <div
    class="flex flex-col w-full gap-4 mt-4"
    [ngClass]="{
      'flex-row': layout === 'horizontal'
    }"
  >
    <div
      class="rounded-10 flex flex-col justify-center items-center gap-2 p-4 hover:bg-white/5 hover:cursor-pointer"
      [ngClass]="{
        'w-1/2 border-1 border-dashed border-white/20': layout === 'horizontal',
        'w-full bg-white/10': layout !== 'horizontal'
      }"
      tabindex="1"
      (click)="showFileLibraryEvent.emit()"
      (keydown)="null"
    >
      <nrc-icon
        class="w-24 h-16 opacity-30"
        [name]="'file-search'"
      />

      <span class="text-base font-normal text-white">
        {{ 'COMPONENTS.FILES.FILE_LIBRARY_MODAL.OPTIONS.SEARCH_FILE_LIBRARY.HEADLINE' | translate }}
      </span>

      <label class="text-sm font-light text-white/50" for="fileDropInput">
        {{ 'COMPONENTS.FILES.FILE_LIBRARY_MODAL.OPTIONS.SEARCH_FILE_LIBRARY.SUBLINE' | translate }}
      </label>
    </div>

    <nrc-file-uploader
      [ngClass]="{
        'w-1/2': layout === 'horizontal',
        'w-full': layout !== 'horizontal'
      }"
      [compactMode]="layout === 'horizontal'"
      tabindex="0"
      [isMultipleUploadEnabled]="false"
      [acceptableMimeTypes]="acceptableMimeTypes"
      (filesChangedEvent)="fileUploadEvent.emit($event)"
    />
  </div>
</div>
